import { useState } from "react";
import TypeSwitch from "modules/data-files/elements/Column-Type-Switch";

import { useGetFileColumnRenameReversers } from "./store";
import Modal from "ui-components/Modal";
import Divider from "ui-components/Divider";
import Button from "ui-components/Button";
import { DataFile } from "interfaces";

interface Props {
  fileIds: string[];
  column: string;
  fileDetails: { [fileId: string]: DataFile.DataFile };
}

const ColumnTypes = ({ fileIds, column, fileDetails }: Props) => {
  const [open, setOpen] = useState(false);
  const reversers = useGetFileColumnRenameReversers(fileIds);

  return (
    <>
      <p className="text-center">
        <span
          className="cursor-pointer uppercase text-primary-main"
          onClick={() => setOpen(true)}
        >
          Change Column Types
        </span>
      </p>
      <Modal
        id={`change-types-for-${column}`}
        show={open}
        handleClose={() => setOpen(false)}
        title={`Change Types for ${column}`}
      >
        <div>
          {fileIds.map((f) => (
            <div
              key={f}
              className="m-2 p-2 grid grid-cols-2 gap-4 items-center border-t first:border-t-0"
            >
              <p className="font-semibold">{fileDetails?.[f]?.name || f}:</p>
              <TypeSwitch
                fileId={f}
                column={reversers[f]?.[column] || column}
                renderAsButtons
                showLabel={false}
              />
            </div>
          ))}
        </div>
        <Divider />
        <p className="text-right">
          <Button onClick={() => setOpen(false)}>Close</Button>
        </p>
      </Modal>
    </>
  );
};

export default ColumnTypes;
